import { X, Check, Zap } from 'lucide-react';
import { Reveal, Eyebrow } from './Reveal';

const ROWS = [
  ['A static brochure page that sits idle', 'An interactive sales engine that works 24/7'],
  ['Basic email form with missing info', 'Smart quote calculators that pre-qualify leads'],
  ['Monthly hosting fees + paid app add-ons', 'Direct lead sync to your SMS & calendar'],
  ['Breaks silently during plugin updates', 'Crash-proof custom architecture, 99.99% uptime'],
  ['You chase every lead by phone', 'Private owner dashboard with every lead queued'],
];

export default function Comparison() {
  return (
    <section id="compare" data-testid="comparison-section" className="py-24 sm:py-32 bg-[#0B1528]/40">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16">
        <Reveal className="text-center">
          <Eyebrow>How It Compares</Eyebrow>
          <h2 className="font-display font-bold tracking-tight text-2xl sm:text-3xl lg:text-4xl">
            Brochure Website vs. <span className="text-gradient-gold">GSLAB Sales Engine</span>
          </h2>
        </Reveal>

        <Reveal i={1}>
          <div className="mt-14 rounded-3xl overflow-hidden border border-slate-700/40">
            <div className="grid grid-cols-2 bg-[#0F1C33]">
              <div className="px-6 sm:px-10 py-6 border-r border-slate-700/40">
                <span className="font-mono-tech text-[11px] tracking-[0.25em] text-slate-500 uppercase">Standard Template Site</span>
              </div>
              <div className="px-6 sm:px-10 py-6 bg-amber-500/5">
                <span className="font-mono-tech text-[11px] tracking-[0.25em] text-amber-300 uppercase flex items-center gap-2">
                  <Zap size={13} /> GSLAB Sales Engine
                </span>
              </div>
            </div>
            {ROWS.map(([bad, good], i) => (
              <div key={i} className="grid grid-cols-2 border-t border-slate-800/60 hover:bg-[#0F1C33]/40 transition-colors duration-300">
                <div className="px-6 sm:px-10 py-5 border-r border-slate-800/60 flex items-start gap-3">
                  <X size={16} className="text-red-400/80 mt-1 shrink-0" />
                  <span className="text-sm text-slate-400">{bad}</span>
                </div>
                <div className="px-6 sm:px-10 py-5 flex items-start gap-3 bg-amber-500/[0.03]">
                  <Check size={16} className="text-amber-400 mt-1 shrink-0" />
                  <span className="text-sm text-slate-200">{good}</span>
                </div>
              </div>
            ))}
          </div>
        </Reveal>

        <Reveal i={2} className="mt-10 text-center">
          <p className="text-slate-300 text-base sm:text-lg max-w-2xl mx-auto">
            The bottom line: turn your website from an idle monthly expense into an{' '}
            <span className="text-amber-300 font-semibold">automated 24/7 lead-generation system</span>.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
